var map = {
	"./002-koala.svg": "P7w/",
	"./010-panda.svg": "5sSh",
	"./020-giraffe.svg": "rPaf",
	"./030-gorilla.svg": "+BKl",
	"./033-bear.svg": "i2eZ",
	"./054-fox.svg": "J2E2",
	"./074-octopus.svg": "Xdy6",
	"./076-rabbit.svg": "Spif",
	"./095-ant.svg": "lBot",
	"./096-ladybug.svg": "bnG3",
	"./103-snail.svg": "8PE7",
	"./116-wolf.svg": "Bj0o",
	"./122-owl.svg": "/Ftz",
	"./128-chicken-2.svg": "YtWe",
	"./143-cat.svg": "coJR",
	"./157-pig.svg": "j3b3",
	"./161-lion.svg": "+F5h",
	"./162-tiger.svg": "zfIT",
	"./165-dog.svg": "+8GS"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "wQMx";


//////////////////
// WEBPACK FOOTER
// ./src/assets/avatar ^\.\/.*$
// module id = wQMx
// module chunks = 1